import PropTypes from "prop-types";
import React from "react";
// @mui
import { Link, ListItemText, Tooltip, Typography } from "@mui/material";
// routes
import { RouterLink } from "src/routes/components";
// components
import { StyledIcon, StyledItem } from "src/components/nav-section/vertical/styles";

// ----------------------------------------------------------------------

export default function NavItem({ item, open, depth, active, onClick, config, externalLink, ...other }) {
    const { title, path, icon, info, children, disabled, caption, roles } = item;

    const subItem = depth !== 1;

    const renderContent = (
        <StyledItem
            disableGutters
            disabled={ disabled }
            active={ active }
            depth={ depth }
            config={ config }
            //
            { ...( !subItem && children && {
                sx: {
                    backgroundColor: "transparent",
                    cursor: "auto",
                    "&:hover": {
                        backgroundColor: "transparent"
                    }
                },
                disableRipple: true
            } ) }
            //
            { ...( subItem && { onClick } ) }
            //
            { ...other }
        >
            <>
                { icon && <StyledIcon size={ config.iconSize }>{ icon }</StyledIcon> }

                { subItem && (
                    <StyledIcon size={ config.iconSize }>
                        {/* <StyledDotIcon active={active}/> */ }
                    </StyledIcon>
                ) }
            </>

            { !( config.hiddenLabel && !subItem ) && (
                <ListItemText
                    primary={ title }
                    secondary={
                        caption ? (
                            <Tooltip title={ caption } placement="top-start">
                                <span>{ caption }</span>
                            </Tooltip>
                        ) : null
                    }
                    primaryTypographyProps={ {
                        noWrap: true,
                        textTransform: subItem ? "capitalize" : "uppercase",
                        // eslint-disable-next-line no-nested-ternary
                        typography: icon ? "body2" : ( active ? "body1" : "body1" ),
                        // eslint-disable-next-line no-nested-ternary
                        color: active ? "text.primary" : ( icon ? "text.primary" : "text.tertiary" )
                    } }
                    secondaryTypographyProps={ {
                        noWrap: true,
                        component: "span",
                        typography: "body1",
                        color: "text.tertiary"
                    } }
                />
            ) }

            { info && (
                <Typography variant="overline" textTransform="uppercase" display="inline-block" ml={ 0.5 } px={ 0.75 } sx={ { color: "white", borderRadius: "8px", backgroundColor: "info.main" } }>
                    { info }
                </Typography>
            ) }

            {/* { !!children && ( */ }
            {/*     <Iconify */ }
            {/*         width={ 16 } */ }
            {/*         icon={ open ? "eva:arrow-ios-downward-fill" : "eva:arrow-ios-forward-fill" } */ }
            {/*         sx={ { ml: 1, flexShrink: 0 } } */ }
            {/*     /> */ }
            {/* ) } */ }
        </StyledItem>
    );

    // Hidden item by role
    if (roles && !roles.includes(`${ config.currentRole }`)) {
        return null;
    }

    // External link
    if (externalLink)
        return (
            <Link
                href={ path }
                target="_blank"
                rel="noopener"
                underline="none"
                color="inherit"
                sx={ {
                    ...( disabled && {
                        cursor: "default"
                    } )
                } }
            >
                { renderContent }
            </Link>
        );

    // Has child
    if (children) {
        return renderContent;
    }

    // Default
    return (
        <Link
            component={ RouterLink }
            href={ path }
            underline="none"
            color="inherit"
            sx={ {
                ...( disabled && {
                    cursor: "default"
                } )
            } }
        >
            { renderContent }
        </Link>
    );
}

NavItem.propTypes = {
    active: PropTypes.bool,
    onClick: PropTypes.func,
    config: PropTypes.object,
    depth: PropTypes.number,
    externalLink: PropTypes.bool,
    item: PropTypes.object,
    open: PropTypes.bool
};
